export enum ChapterTextEnum {
    FRONTEND = 'frontend',
    BACKEND = 'backend'
}
